import { useGenericParameters } from "@/composables/useGenericParameters";
import { parameters } from "@/parameters/parameters";

export function useParameters(dateString: string) {
	return useGenericParameters(dateString, parameters);
}
